import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  Typography,
  Paper,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";

const ContractTRXBalance = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchBalance = async () => {
    setError(null);
    setResponse(null);
    setLoading(true);

    try {
      const res = await axios.get(
        "https://api.example.com/api/v1/tronvault/contract/trx/balance"
      );
      setResponse(res.data);
    } catch (err) {
      console.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, width:'60%',paddingX:'10%', mx: "auto", mt: 5 }}>
      <Typography
        variant="h6"
        gutterBottom
        dir="rtl"
        sx={{ textAlign: "right" }}
      >
        دریافت موجودی قرارداد TRX
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={fetchBalance}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "دریافت موجودی"
          )}
        </Button>

        {response && (
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2">پاسخ موفق:</Typography>
            <pre
              style={{
                backgroundColor: "#f9f9f9",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(response, null, 2)}
            </pre>
          </Paper>
        )}

        {error && (
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Alert severity="error">خطا</Alert>
            <pre
              style={{
                backgroundColor: "#fff0f0",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(error, null, 2)}
            </pre>
          </Paper>
        )}
      </Box>
    </Paper>
  );
};

export default ContractTRXBalance;
